module.exports = __webpack_public_path__ + "img/layout_form_horizontal_icon.0a0917ec.svg";